import { Feature } from 'geojson';
import { LatLng } from 'leaflet';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IAnnotationService } from '../annotation.service';
import { ISegmentation, ISegmentationFeature } from '../annotations.interface';
import { DRAW_CONTROL_MODE } from '../containers/Drawing.container';
import { IFreeDrawSegmentationService } from '../freeDrawSegmentation.service';
import { AnnotationToolType } from '../submodules/annotationTypes/models/annotationToolType';
import { IAnnotationTypeOptions } from '../submodules/annotationTypes/models/annotationTypeOptions';
import { IUndoRedoHistory } from '../undoRedoHistory.service';
import { DrawControl } from './DrawControl';

interface IDrawingComponentProps {
  activeAnnotationTypeId: string | undefined;
  activeAnnotationTypeOptions: IAnnotationTypeOptions | undefined;
  areCursorGuidesEnabled: boolean;
  selectorType: AnnotationToolType | null;
  fillOpacity: number;
  color: string;
  controlMode: DRAW_CONTROL_MODE;
  stopAction: boolean;
  undoRedoHistory: IUndoRedoHistory;
  annotationService: IAnnotationService;
  freeDrawSegmentationService: IFreeDrawSegmentationService;
  selectedSegmentation?: ISegmentation;
  freeDrawInProgress: boolean;
  freeDrawSegmentationFeature?: ISegmentationFeature;
  currentCursorPosition?: LatLng;
  isImprovedVisibilityCursorEnabled: boolean;
  onAnnotationCreated: (annotation: Feature) => void;
  onAnnotationCopied: (id: string) => void;
  onAnnotationPasted: (annotation: Feature, id: string) => void;
  onAnnotationEdited: (id: string | undefined, annotation: Feature) => Promise<void>;
  onAnnotationRemove: (id: string) => Promise<void>;
  onMouseMove: (latlng?: LatLng) => void;
  onEditEnabled: () => void;
  onEditDisabled: () => void;
  onFreeDrawStarted: (annotation: Feature) => void;
  onFreeDrawCancel: () => Promise<boolean> | undefined;
  onFreeDrawDelete: () => void;
}

export const DrawingComponent = observer((props: IDrawingComponentProps): ReactElement => {
  return (
    <DrawControl
      activeAnnotationTypeId={props.activeAnnotationTypeId}
      activeAnnotationTypeOptions={props.activeAnnotationTypeOptions}
      selectorType={props.selectorType}
      color={props.color}
      fillOpacity={props.fillOpacity}
      stopActions={props.stopAction}
      onDrawCreated={props.onAnnotationCreated}
      onDrawCopied={props.onAnnotationCopied}
      onDrawPasted={props.onAnnotationPasted}
      onDrawEdited={props.onAnnotationEdited}
      onDrawingRemove={props.onAnnotationRemove}
      onMouseMove={props.onMouseMove}
      controlMode={props.controlMode}
      undoRedoHistory={props.undoRedoHistory}
      freeDrawSegmentationService={props.freeDrawSegmentationService}
      onEditEnabled={props.onEditEnabled}
      onEditDisabled={props.onEditDisabled}
      selectedSegmentation={props.selectedSegmentation}
      freeDrawFeature={props.freeDrawSegmentationFeature}
      freeDrawInProgress={props.freeDrawInProgress}
      onFreeDrawStarted={props.onFreeDrawStarted}
      onFreeDrawCancel={props.onFreeDrawCancel}
      onFreeDrawDelete={props.onFreeDrawDelete}
      cursorPosition={props.currentCursorPosition}
      annotationService={props.annotationService}
      isImprovedVisibilityCursorEnabled={props.isImprovedVisibilityCursorEnabled}
      areCursorGuidesEnabled={props.areCursorGuidesEnabled}
    />
  );
});
